import request from '@/utils/request'

// 查询业务中心数据
export function getBusinessQuery(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/business.businessQuery',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询会员数据
export function getShopVipUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.queryShopTelUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询商品数据
export function getProductList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/product.queryProductList',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询订单数据
export function getStoreOrderCart(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/order.queryStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}